import { Component, inject, input, output } from "@angular/core";
import { Router } from "@angular/router";
import { ApiClientConstant } from "@cureskin/api-client";
import { CsIconModule } from "@components/icon";
import { ConsultationSessionService } from "@services/consultation-session-service";

@Component({
  selector: "app-submit-defualt-answers-banner",
  imports: [CsIconModule],
  templateUrl: "./submit-defualt-answers-banner.component.html",
})
export class SubmitDefualtAnswersBannerComponent {
  private readonly router = inject(Router);
  private readonly consultationSessionService = inject(ConsultationSessionService);

  consultation = input<Table.ConsultationSession | null>(null);
  thumbnailUrl = input<string | null>(null);
  addEvents = output();

  readonly ApiClientConstant = ApiClientConstant;

  get consultationClass(): string {
    return this.consultation()?.get('PrivateMainConcernClass') || ApiClientConstant.Regimen.Class.FACE;
  }

  handleClick(): void {
    this.addEvents.emit();
    const consultation = this.consultation();
    if (consultation) {
      this.consultationSessionService.setPendingConsultationSession(consultation);
      this.router.navigate(['/submit-default-answers']);
    }
  }
}
